import dayjs, { Dayjs } from "dayjs";
import { useMemo } from "react";

export function useDurationOrDatesToRange(
  values: Partial<{ start: string; end: string; duration: string }>
): [Dayjs, Dayjs] {
  const { start, end, duration } = values;
  return useMemo(() => {
    if (start && end) return [dayjs(start), dayjs(end)];
    if (duration) {
      const val = duration.slice(1, -1);
      const unit = duration.slice(Math.max(0, duration.length - 1));
      const mOrY = unit === "M" ? "months" : "years";
      const dOrmOrY = unit === "D" ? "days" : mOrY;
      return [dayjs().subtract(Number.parseInt(val), dOrmOrY), dayjs()];
    }
    return [dayjs().subtract(24, "hours"), dayjs()];
  }, [start, end, duration]);
}
